import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { AlloyBackground } from './AlloyBackground';
import { BookIcon, ChartIcon, HomeIcon, SettingsIcon } from './Icons';

const navigation = [
  { to: '/', label: '今日', icon: HomeIcon },
  { to: '/library', label: '词库', icon: BookIcon },
  { to: '/insights', label: '洞察', icon: ChartIcon },
  { to: '/settings', label: '设置', icon: SettingsIcon },
];

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="app-shell">
      <AlloyBackground />
      <aside className="side-rail" aria-label="主导航">
        <NavLink className="brand" to="/" aria-label="MNEMOFLUX 首页">
          <img src="/brand-mark.svg" alt="" />
          <span>MNEMOFLUX</span>
        </NavLink>
        <nav>
          {navigation.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => `nav-item ${isActive ? 'is-active' : ''}`}>
              <Icon size={22} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <p className="rail-foot">词忆流 · LOCAL FIRST</p>
      </aside>
      <main className="app-main">{children}</main>
      <nav className="bottom-nav" aria-label="主导航">
        {navigation.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => `nav-item ${isActive ? 'is-active' : ''}`}>
            <Icon size={22} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
